export const i18nKeys = {
	common: {
		selectedCountOne: 'common.selectedCountOne',
		selectedCountOther: 'common.selectedCountOther',
		error: {
			title: 'common.error.title',
			description: 'common.error.description',
			refresh: 'common.error.refresh',
			logout: 'common.error.logout',
		},
	},
	nav: {
		home: 'nav.home',
		frekuentSpots: {
			group: 'nav.frekuentSpots.group',
			pointsOfSale: 'nav.frekuentSpots.pos',
			products: 'nav.frekuentSpots.products',
			personalization: 'nav.frekuentSpots.personalization',
		},
		users: {
			group: 'nav.users.group',
			appUsers: 'nav.users.appUsers',
			nfcTags: 'nav.users.nfcTags',
			userSupport: 'nav.users.userSupport',
		},
		benefits: {
			group: 'nav.benefits.group',
			promotions: 'nav.benefits.promotions',
			packs: 'nav.benefits.packs',
		},
		finance: {
			group: 'nav.finance.group',
			transactions: 'nav.finance.transactions',
			reconciliations: 'nav.finance.reconciliations',
		},
		tools: {
			group: 'nav.tools.group',
			reports: 'nav.tools.reports',
			alerts: 'nav.tools.alerts',
		},
	},
	features: {
		frekuentSpots: {
			pointsOfSales: {
				title: 'features.frekuentSpots.pos.title',
				description: 'features.frekuentSpots.pos.description',
				overviewAlerts: {
					title: 'features.frekuentSpots.pos.overviewAlerts.title',
					marketplaceCta: 'features.frekuentSpots.pos.overviewAlerts.marketplaceCta',
					goToAlerts: 'features.frekuentSpots.pos.overviewAlerts.goToAlerts',
					emptyDescription: 'features.frekuentSpots.pos.overviewAlerts.emptyDescription',
					emptyLinkText: 'features.frekuentSpots.pos.overviewAlerts.emptyLinkText',
				},
			},
			devices: {
				title: 'features.frekuentSpots.devices.title',
			},
			evaDts: {
				description: 'features.frekuentSpots.evaDts.description',
			},
			irp: {
				description: 'features.frekuentSpots.irp.description',
			},
			activity: {
				description: 'features.frekuentSpots.activity.description',
			},
			connectivity: {
				description: 'features.frekuentSpots.connectivity.description',
			},
		},
	},
};
